import type { Calculations } from '@features/glossary';
import { Slide } from '@features/powerpoint';
import { page } from './components/page';

export type CalculationsPaginationConfig = {
  entriesPerColumnPerPage: number[];
  totalPages: number;
};

export const calculationsSlides = (
  calculations: Calculations,
  pagination: CalculationsPaginationConfig
): Slide[] =>
  Array.from(
    { length: pagination.totalPages },
    (_, pageIndex): Slide =>
      page(calculations, pageIndex, pagination.entriesPerColumnPerPage)
  );
